import WasteSelectorTypes from "../WasteSelectorTypes";

export const ContainerSVG = (
    {
        title = "",
        type = 'gl',
        width = 30,
        height = 40.754
    }
) => {
    const { SVG, fillColor, borderColor, contrastColor } = WasteSelectorTypes[type] || WasteSelectorTypes['none'];
    return (
        <SVG
            title={title}
            fillColor={fillColor}
            borderColor={borderColor}
            contrastColor={contrastColor}
            width={width}
            height={height}
        />
    );
};
